import ldgcPlayers from '../data/ldgc.js';
import LdgcLogo from '../assets/ldgc-64.png';
import RatingPage from './RatingPage';

const LdgcRatings = () => {
  return (
    <RatingPage playerData={ldgcPlayers}>
      LDGC Team <img src={LdgcLogo} alt="" />
    </RatingPage>
  );
};

export default LdgcRatings;
